import React, { useEffect, useState } from 'react';
import { supabase } from '../../../supabaseClient';

// O `value` salvo pode vir como `data.Key` (com o bucket no início) ou como
// `data.path` (sem bucket); o createSignedUrl espera o caminho sem o bucket.
const toStoragePath = (storagePath, bucket) => {
  if (!storagePath) return null;
  if (storagePath.startsWith(`${bucket}/`)) return storagePath.slice(bucket.length + 1);
  return storagePath;
};

const isPdfPath = (path) => /\.pdf(\?.*)?$/i.test(path || '');

const DocumentPreviewModal = ({ isOpen, value, bucket = 'installment', onClose }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!isOpen || !value) return undefined;
    let active = true;
    setUrl(null);
    setFailed(false);
    const path = toStoragePath(value, bucket);
    supabase.storage
      .from(bucket)
      .createSignedUrl(path, 3600)
      .then(({ data, error }) => {
        if (!active) return;
        if (error || !data?.signedURL) {
          setFailed(true);
          return;
        }
        setUrl(data.signedURL);
      });
    return () => {
      active = false;
    };
  }, [isOpen, value, bucket]);

  if (!isOpen || !value) return null;

  const isPdf = isPdfPath(value);

  const renderViewer = () => {
    if (!url) {
      let message = 'Carregando...';
      if (failed) message = 'Não foi possível carregar o documento.';
      return <span style={{ color: '#fff', padding: 24 }}>{message}</span>;
    }
    if (isPdf) {
      return (
        <iframe
          src={url}
          title="Documento"
          style={{ width: '100%', height: '75vh', border: 'none', background: '#fff' }}
        />
      );
    }
    return (
      <img
        src={url}
        alt="Documento anexado"
        style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain' }}
      />
    );
  };

  return (
    <div
      className="fd-modal-overlay"
      onClick={onClose}
      style={{ zIndex: 1100 }}
    >
      <div
        className="fd-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 900, width: '92vw', maxHeight: '92vh', display: 'flex', flexDirection: 'column' }}
      >
        <div className="fd-modal-header">
          <h3 className="fd-modal-title">Visualizar Documento</h3>
          <div style={{ display: 'flex', gap: 8 }}>
            {url && (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="fd-btn-green"
                style={{ padding: '6px 12px', fontSize: 11, textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}
              >
                ABRIR EM NOVA ABA
              </a>
            )}
            <button
              className="fd-btn-close"
              type="button"
              onClick={onClose}
              style={{ background: '#ED2D2D', color: '#fff', borderColor: '#ED2D2D' }}
            >
              X FECHAR
            </button>
          </div>
        </div>

        <div
          style={{
            flex: 1,
            overflow: 'auto',
            background: '#1a1a1a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 12,
          }}
        >
          {renderViewer()}
        </div>
      </div>
    </div>
  );
};

export default DocumentPreviewModal;
